<div class="mango-folder-upload" *ngIf="listView === 'grid'">
  <div
    class="progress-circle-upload"
    [ngClass]="{ completed: data.progress || 0 >= 100 }"
  >
    <i class="fa fa-folder"></i>
    <circle-progress
      *ngIf="data?.progress || 0 < 100"
      [percent]="data.progress || 0"
      [radius]="40"
      [outerStrokeWidth]="3"
      [innerStrokeWidth]="0"
      [outerStrokeColor]="'#4882C2'"
      [innerStrokeColor]="'##E7E8EA'"
      [animation]="false"
      [animationDuration]="300"
      [showSubtitle]="false"
      [space]="-10"
    ></circle-progress>
  </div>

  <div class="details">
    <a href="javascript:void(0);" (click)="openModalDetails(template)"
      >View Folder</a
    >
  </div>

  <div class="footer-left">
    <span>{{ data.realName }}</span>
  </div>

  <div class="footer-right">
    <span>{{ totalFiles }} Files</span>
  </div>
</div>

<!-- inline -->

<div
  class="mango-folder-upload-inline"
  *ngIf="listView === 'list'"
  [ngClass]="{ 'inline-item': listView === 'list' }"
>
  <div class="inline-item">
    <div class="inline-wrapper">
      <div>
        <i class="fa fa-folder"></i>
      </div>

      <div class="inline-title">
        <span>{{ data.realName }}</span>
      </div>

      <div>
        <a href="javascript:void(0);" (click)="openModalDetails(template)"
          >View Folder</a
        >
      </div>

      <div>
        <span *ngIf="data.progress"
          >{{ data.progress | number : "1.0-0" }}%</span
        >
        <span *ngIf="!data.progress">0%</span>
      </div>

      <div>
        <span class="image-ext">{{ totalFiles }} Files</span>
      </div>
    </div>

    <progressbar [value]="data.progress|| 0"></progressbar>
  </div>
</div>

<!-- template modal -->

<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      <strong>Folder: </strong>
      <span>{{ data.realName }}</span>
    </h4>

    <div class="pull-right">
      <mango-list-view
        [selected]="selectedListView"
        (onSelected)="onSelectedHandle($event)"
      ></mango-list-view>
    </div>
  </div>
  <div class="modal-body">
    <div
      class="wrapper-folder-grid"
      [ngClass]="{ 'inline-wrapper': selectedListView === 'list' }"
    >
      <ng-container
        *ngFor="let fileMeta of listSingleFilesPaginateUI; let i = index"
      >
        <ng-container *ngIf="fileMeta.type !== 'mng-compressed'">
          <div [ngClass]="{ 'inline-item': selectedListView === 'list' }">
            <mango-item-upload
              [data]="fileMeta"
              [listView]="selectedListView"
            ></mango-item-upload>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <!--    <div class="show-more" *ngIf="showMoreLimit">-->
    <!--      <button class="btn btn-primary btn-sm btn-block" (click)="btnShowMore()">Show More ...</button>-->
    <!--    </div>-->
  </div>
  <div class="modal-footer">
    <span>{{ totalFiles }} Files</span>
    <button
      type="button"
      class="btn btn-default"
      data-dismiss="modal"
      (click)="modalRef.hide()"
    >
      Close
    </button>
  </div>
</ng-template>
